import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy-policy-modal',
  template: `
    <div class="modal-column">
      <a (click)="close($event)" class="icon close-popup" data-id="privacy-close-href">
        <i class="fal fa-times"></i>
      </a>
      <app-privacy-policy></app-privacy-policy>
    </div>
  `,
})
export class PrivacypolicyModalComponent {
  modal: boolean = true;

  constructor(private ref: NgbActiveModal) {}

  public close($event: Event): void {
    $event.preventDefault();
    this.ref.close();
  }

  public reject(): void {
    this.ref.dismiss();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/privacypolicy-modal.component.ts